import React from 'react'
import './Schedule.scss'

function Schedule() {
  return (
    <div>Schedule</div>
  )
}

export default Schedule